import React, { useState } from 'react';
import { Card, Col, Button } from 'react-bootstrap';
import ProductCategoryFilter from './ProductCategoryFilter';
import ProductTable from './ProductTable';



const ProductFilter = () => {
  const [mincost, setMincost] = useState(0);
  const [maxcost, setMaxcost] = useState(5000);
  const [search, setSearch] = useState("");

  const [page, setPage] = useState(1)
  const [limit, setlimit] = useState(10)

  // const [productListFn, { data: productList, isSuccess, error, isLoading }] = useProductListMutation();



  const [selectedRows, setSelectedRows] = useState([]);

  const handleCheckboxChange = (row) => {

    const isSelected = selectedRows.some((r) => r.id === row.id);

    if (isSelected) {
      setSelectedRows(selectedRows.filter((r) => r.id !== row.id));
    } else {
      setSelectedRows(prev => ([...prev, row]));
    }
  };
  const [selectedCategry, setSelectedCategory] = useState([]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [selectedSizes, setSelectedSizes] = useState([]);

  const handleClearAll = () => {
    setSelectedColors([]);
    setSelectedCategory('');
    setSelectedSizes([]);
    setMincost('');
    setMaxcost('');
    setPage(1)
  };



  return (
    <React.Fragment>
      <Col xl={3} lg={4}>
        <Card className="overflow-hidden">
          <Card.Header>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5 className="card-title mb-0">Filters</h5>
              </div>
              <div className="flex-shrink-0">
                <Button onClick={() => handleClearAll()} className="text-decoration" id="clearall">Clear All</Button>
              </div>
            </div>
          </Card.Header>

          {/* Product Category Filter */}
          <ProductCategoryFilter
            setMaxcost={setMaxcost}
            maxcost={maxcost}
            mincost={mincost}
            setMincost={setMincost}
            selectedCategry={selectedCategry}
            setSelectedCategory={setSelectedCategory}
            setSelectedSizes={setSelectedSizes}
            selectedSizes={selectedSizes}
            selectedColors={selectedColors}
            setSelectedColors={setSelectedColors}

            setPage={setPage}
            page={page}
            limit={limit}
            setlimit={setlimit}
            search={search}
            setSearch={setSearch}
          />

        </Card>
      </Col>

      <Col xl={9} lg={8}>

        {/* <CustomTable key="Product List" columns={columns} /> */}
        <ProductTable
          // productListFn={productListFn} 
          // data={productList?.response}
          setPage={setPage}
          page={page}
          limit={limit}
          setlimit={setlimit}
          search={search}
          setSearch={setSearch}
          handleCheckboxChange={handleCheckboxChange} selectedRows={selectedRows}
          selectedCategry={selectedCategry}
          setSelectedSizes={setSelectedSizes} selectedSizes={selectedSizes}
          setMaxcost={setMaxcost} maxcost={maxcost} mincost={mincost} setMincost={setMincost}
          selectedColors={selectedColors}

        />
      </Col>
    </React.Fragment>
  );
};

export default ProductFilter;
